import React, { useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { publicAssets } from '@utils/url.utils';
import { Content, Description, Details, Image, Phone, Question, Wrapper } from './Support.elements';
import { IColors } from '../../interfaces/Conference';

export interface SupportProps {
    withoutMargin?: boolean;
    withoutBackground?: boolean;
    colors?: IColors;
}

const SupportTemplate: FC<SupportProps> = ({ withoutMargin, withoutBackground, colors }) => {
    const { t } = useTranslations();

    return (
        <Wrapper withoutMargin={withoutMargin} withoutBackground={withoutBackground}>
            <Question>{t('cart.support.question')}</Question>
            <Content>
                <Image src={publicAssets('/contact_person_shop.png')} />
                <Details>
                    <Description>{t('cart.support.description')}</Description>
                    <Phone href={`tel:${t('cart.support.phone')}`} colors={colors}>{t('cart.support.phone')}</Phone>
                </Details>
            </Content>
        </Wrapper>
    );
};

export default SupportTemplate;
